import { Card } from 'components/Card';
import { GameBoardPlace } from 'game/GameBoardPlace';

export enum MagicPlace {
    AFTER = 'AFTER',
    BEFORE = 'BEFORE',
}
export class MagicItem {
    moveCard: Card;
    secondMoveCard?: Card;
    to: GameBoardPlace;
    targetCard: Card | null;
    place: MagicPlace;

    constructor(moveCard: Card, to: GameBoardPlace, place: MagicPlace, targetCard: Card | null, secondMoveCard?: Card) {
        this.moveCard = moveCard;
        this.secondMoveCard = secondMoveCard;
        this.to = to;
        this.place = place;
        this.targetCard = targetCard;
    }
}
